module.exports = {
    "name": "",
    "description": "",
    "largeImageUrl": "",
    "mediumImageUrl": "",
    "websiteUrl": "",
    "timeDescription": "",
    "date": Math.round(new Date().getTime()/1000),
    "isMcc": true,
    "active": true,
    "dynamicLink1": { id: null, name: "", url: "", imageUrl: "" },
    "dynamicLink2": { id: null, name: "", url: "", imageUrl: "" }
};
